import { render, staticRenderFns } from "./CommonContentEditComponent.vue?vue&type=template&id=09b48fde"
import script from "./CommonContentEditComponent.vue?vue&type=script&lang=js"
export * from "./CommonContentEditComponent.vue?vue&type=script&lang=js"
import style0 from "./CommonContentEditComponent.vue?vue&type=style&index=0&id=09b48fde&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports